const styles = {
  sliderWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: {
      xs: '21px',
      sm: '30',
    },
    '& .swiper': {
      width: '100%',
    },

    '& .swiper-slide': {
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      height: 'auto',
      borderRadius: '16px',
      overflow: 'hidden',
    },
    '& .swiper-slide img': {
      display: 'block',
      width: '100%',
    },
  },
  sliderMainContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  sliderContainer: {
    zIndex: 2,
  },
  buttonBlock: {
    display: 'flex',
    paddingTop: {
      xs: '24px',
      md: 0,
    },
    '& button': {
      padding: 0,
      width: {
        xs: '40px',
        md: '48px',
      },
      height: {
        xs: '40px',
        md: '48px',
      },
      marginLeft: {
        xs: '24px',
        md: 0,
      },
      '& svg': {
        width: '100%',
        height: '100%',
      },
    },
    justifyContent: {
      xs: 'flex-end',
      md: 'space-between',
    },
    position: {
      xs: 'relative',
      md: 'absolute',
    },
    top: {
      xs: 'unset',
      md: '50%',
    },
    left: {
      xs: 'unset',
      md: '0',
    },
    transform: {
      xs: 'translateY(0)',
      md: 'translateY(-50%)',
    },
    width: {
      xs: 'auto',
      md: '100%',
    },
    zIndex: 1,
  },
  slide: {
    width: '100%',
    lineHeight: 0,
    '& .frame': {
      width: '100%',
      height: 'auto',
      '& img': {
        width: '100%',
        height: 'auto',
      },
      '& div': {
        width: '100%',
        maxWidth: '100% !important',
      },
    },
    '& .image': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
  prev: {
    transform: 'rotate(180deg)',
    '& button': {
      marginLeft: 0,
    },
  },
};

export default styles;
